import { render } from "./BoostItem.vue?vue&type=template&id=2541936c&scoped=true"
import script from "./BoostItem.vue?vue&type=script&lang=js"
export * from "./BoostItem.vue?vue&type=script&lang=js"

import "./BoostItem.vue?vue&type=style&index=0&id=2541936c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2541936c"]])

export default __exports__